// extracted by mini-css-extract-plugin
export var faqContainer = "index-module--faqContainer--LzTWb";
export var answer = "index-module--answer--d2znY";